<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <div class="fl m-r-30" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加轮播
        </router-link>
      </div>
      <div class="fl w-260">
        <el-input placeholder="请输入标题/内容" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="id"
      label="编号">
      </el-table-column>
      <el-table-column
      prop="title"
      label="标题">
      </el-table-column>
      <el-table-column
      prop="url"
      label="跳转地址">
      </el-table-column>
      <el-table-column
      prop="img"
      label="图片"
      width="250">
        <template scope="scope">
          <el-popover
            v-if="scope.row.img"
            placement="right-end"
            width="600"
            trigger="click">
            <img :src="scope.row.img" width="100%">
            <img :src="scope.row.img" width="200" height="95" slot="reference">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
      label="状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1" style="color:#0c0">正常</span>
            <span v-else-if = "scope.row.status ==0"  style="color:#bb0">{{ scope.row.status | status }}</span>
            <span v-else-if = "scope.row.status ==-1" style="color:#d00">{{ scope.row.status | status }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="类型">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.type ==1">内部跳转</span>
            <span v-else-if = "scope.row.type ==2">外链</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      width="200">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="$router.push({ name: 'lunboEdit', params: { id: scope.row.id }})">编辑</el-button>
              <!-- <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button> -->
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'lunbo'"></btnGroup>
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        multipleSelection: [],
        formSearch: {
          type: '',
          title: '',
        },
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/lunbo/', item.id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '删除成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/lunbo', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      init() {
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('lunbo-save')
      },
      editShow() {
        return _g.getHasRule('lunbo-update')
      },
      deleteShow() {
        return _g.getHasRule('lunbo-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?960c0802